import React from "react";

import API from "../../../../utils/API";
import { Modal } from "reactstrap";
import { withRouter } from "react-router-dom";

import InputField from "../../../../components/inputs/inputField";
import PagePreviewFrame from "../../../../views/pages/components/pagePreviewFrame";

import SelectField from "../../../../components/inputs/selectField";
import ToggleField from "../../../../components/inputs/toggleField";
import Joyride from "react-joyride";
import tutorials from "../../../../layouts/components/tutorials";

const ENV =
    process.env.NODE_ENV === "production"
        ? window.location.href.includes("planner.simple.events")
            ? `https://admin-api.simple.events/`
            : `https://beta-api.simple.events/`
        : `http://${window.location.hostname}:5015/`;
class FormsTemplateCenter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: this.props.name ? this.props.name : "",
            submitting: false,
            selectedSection: 0,
            isConfirmation: false,
            templateSelected: null,
            countingKey: 0,
            formName: "",
            campaignName: "",
            formType: "",
            confirmationEmailEnabled: false,
            confirmationEmail: "",
            runPageTutorial: false,
            requiredFields: {
                name: false,
                formType: false,
                confirmationEmail: false,
            },
        };
    }

    selectSection = (section) => {
        const { countingKey } = this.state;
        this.setState({
            selectedSection: section,
            isConfirmation: false,
            templateSelected: null,
            countingKey: countingKey + 1,
            formName: "",
        });
    };
    setCampaignName = (campaignName) => {
        this.setState({ campaignName: campaignName });
    };
    selectTemplate = (templateId) => {
        this.setState({ templateSelected: templateId });
    };

    handleActionButtonLogic = () => {
        const { isConfirmation, templateSelected, selectedSection } = this.state;
        switch (selectedSection) {
            case 0:
                if (templateSelected && !isConfirmation) {
                    this.setConfirmation(true);
                } else if (templateSelected && isConfirmation) {
                    this.createForm();
                }
                break;
            case 1:
                break;
            case 2:
                this.createForm();
                break;
            default:
                break;
        }
    };

    setConfirmation = (isConfirmation) => {
        this.setState({
            isConfirmation: isConfirmation,
            countingKey: this.state.countingKey + 1,
        });
    };

    createForm = async (callback) => {
        const { orgId, eventId, toggle, addForm, programId } = this.props;
        const {
            templateSelected,
            campaignName,
            selectedSection,
            confirmationEmail,
            confirmationEmailEnabled,
            formType,
        } = this.state;
        let payload = {};
        let valid = true;
        const requiredFields = this.state.requiredFields;

        switch (selectedSection) {
            case 0:
                let isPlatformTemplate = false;

                if (campaignName === "") {
                    valid = false;
                    requiredFields.name = true;
                }

                if (
                    this.props.platformTemplates.find(
                        (template) => template._id == templateSelected
                    )
                ) {
                    isPlatformTemplate = true;
                }
                payload = {
                    templateId: templateSelected,
                    name: campaignName,
                    isPlatformTemplate: isPlatformTemplate,
                };

                break;
            case 2:
                if (campaignName === "") {
                    valid = false;
                    requiredFields.name = true;
                } else {
                    requiredFields.name = false;
                }
                if (formType === "") {
                    valid = false;
                    requiredFields.formType = true;
                } else {
                    requiredFields.formType = false;
                }
                if( confirmationEmailEnabled && confirmationEmail === "") {
                    valid = false;
                    requiredFields.confirmationEmail = true;
                } else {
                    requiredFields.confirmationEmail = false;
                }

                payload = {
                    name: campaignName,
                    formType: formType.value,
                    confirmationEmailEnabled: confirmationEmailEnabled,
                };

                if (confirmationEmailEnabled) {
                    payload.confirmationEmail = confirmationEmail;
                }
                break;
            default:
                break;
        }

        if (valid) {
            if (!programId) {
                await API()
                    .post(`Organizations/${orgId}/events/${eventId}/form`, payload)
                    .then((res) => {
                        if (res.data) {
                            addForm(res.data, () => {
                                toggle();
                                this.props.history.push(
                                    `/${orgId}/events/${eventId}/forms/${res.data._id}`
                                );
                            });
                        }
                    });
            } else {
                this.props.addProgramForm(payload, () => {
                    toggle();
                });
            }
        } else {
            this.setState({ submitting: false, requiredFields: requiredFields });
        }
    };

    onCancel = () => {
        const { isConfirmation } = this.state;

        if (isConfirmation) {
            this.setConfirmation(false);
        } else {
            this.props.toggle();
        }
    };

    handleJoyrideCallback = (data) => {
        const { status } = data;
        const finishedStatuses = ["finished", "skipped"];
        if (finishedStatuses.includes(status)) {
            this.setState({ runPageTutorial: false });
        }
    };

    startTour = () => {
        // Add 3 second delay before starting the tour
        setTimeout(() => {
            this.setState({ runPageTutorial: true });
        }, 1000);
    };

    render() {
        const { isOpen, toggle, orgId, eventId, programId } = this.props;
        const {
            campaignName,
            requiredFields,
            selectedSection,
            isConfirmation,
            templateSelected,
            countingKey,
            confirmationEmailEnabled,
            confirmationEmail,
            formType,
            runPageTutorial,
        } = this.state;
        let localTemplates = this.props.templates ? this.props.templates : [];
        let localPlatformTemplates = this.props.platformTemplates
            ? this.props.platformTemplates
            : [];
        let data = [...localPlatformTemplates, ...localTemplates];
        if (selectedSection === 1) {
            data = data.filter((template) => {
                if (
                    localTemplates.find(
                        (localTemplate) => localTemplate._id == template._id
                    )
                ) {
                    return true;
                }
                return false;
            });
        }

        if (templateSelected && isConfirmation) {
            data = data.filter((template) => template._id == templateSelected);
        }

        return (
            <div>
                <Joyride
                    callback={this.handleJoyrideCallback}
                    continuous
                    run={runPageTutorial}
                    floaterProps={{
                        styles: {
                            wrapper: {
                                zIndex: 2000,
                            },
                        },
                    }}
                    scrollOffset={64}
                    scrollToFirstStep
                    showProgress={false}
                    hideCloseButton={false}
                    showSkipButton
                    steps={tutorials["FormTemplateCenter"]}
                    styles={{
                        options: {
                            zIndex: 2000,
                        },
                        buttonNext: {
                            background: "var(--primary)",
                            border: "var(--primary--border)",
                            color: "var(--white)",
                            fontWeight: 600,
                            padding: "10px 15px",
                            fontSize: 14,
                            width: 65,
                            height: 30,
                        },
                        buttonSkip: {
                            background: "var()",
                            border: "var(--primary--border)",
                            color: "var(--primary)",
                            fontWeight: 600,
                            padding: "10px 15px",
                            fontSize: 14,
                        },
                        buttonBack: {
                            color: "#007bff",
                        },
                    }}
                />
                <Modal
                    isOpen={isOpen}
                    style={{}}
                    toggle={toggle}
                    className={`large templateCenterModal`}
                >
                    <button
                        onClick={toggle}
                        style={{
                            position: "absolute",
                            right: 5,
                            top: 5,
                            padding: 7,
                            zIndex: 100,
                        }}
                    >
                        <i className="las la-times"></i>
                    </button>
                    <div className={`templateCenterContainer`} style={{}}>
                        <div className="sideNav">
                            <h1>Template Center</h1>
                            <div className="explorePanel">
                                <p>EXPLORE</p>
                                <button
                                    type="button"
                                    tabindex="0"
                                    className={`sideNav  ${selectedSection === 0 ? "selectedInverted" : ""
                                        }`}
                                    style={{ textTransform: "capitalize", padding: "7px 10px" }}
                                    onClick={() => this.selectSection(0)}
                                >
                                    All Templates
                                </button>
                                {/*  <button type="button" tabindex="1" className={`sideNav  ${selectedSection == 1 ? 'selectedInverted' : ''}`} style={{ textTransform: 'capitalize', padding: '7px 10px' }} onClick={() => this.selectSection(1)}>
                                    My Saved Templates
                                </button> */}
                                <button
                                    type="button"
                                    tabindex="2"
                                    className={`sideNav  ${selectedSection === 2 ? "selectedInverted" : ""
                                        }`}
                                    style={{ textTransform: "capitalize", padding: "7px 10px" }}
                                    onClick={() => this.selectSection(2)}
                                >
                                    Start From Scratch
                                </button>
                            </div>
                        </div>

                        <div
                            style={{ height: "calc(100vh - 80px)" }}
                            className="templatesContainer"
                        >
                            {isConfirmation ? (
                                <div>
                                    <div
                                        style={{
                                            alignContent: "baseline",
                                            height: "calc(100vh - 233px)",
                                            overflow: "auto",
                                            display: "flex",
                                            flexFlow: "wrap",
                                        }}
                                    >
                                        <div>
                                            {data.map((template, _index) => {
                                                let renderURL = programId
                                                    ? `Organizations/${orgId}/programs/${programId}/render/platformFormRender/`
                                                    : `Organizations/${orgId}/events/${eventId}/pages/render/platformFormRender/`;
                                                return (
                                                    <div>
                                                        <div
                                                            style={{
                                                                opacity: "1",
                                                                width: 455,
                                                                height: 630,
                                                                background: "#FFF",
                                                                margin: "10px 50px 40px 0px",
                                                            }}
                                                        >
                                                            <div
                                                                className="noselect emailPreviewWindow Frame templateCenter formFocus"
                                                                style={{ width: "100%" }}
                                                            >
                                                                <PagePreviewFrame
                                                                    ENV={ENV}
                                                                    key={countingKey}
                                                                    renderURL={renderURL}
                                                                    pageProperties={{}}
                                                                    focusedComponent={""}
                                                                    simulatedUser={{ value: "" }}
                                                                    simulatedSession={{ value: false }}
                                                                    renderOnly={true}
                                                                    formId={template._id}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        <div className="mt-10" style={{ width: "50%" }}>
                                            <InputField
                                                label={"Form Name"}
                                                value={this.state.campaignName}
                                                errorTrigger={this.state.campaignName === ""}
                                                inputStyle={{
                                                    fontSize: 28,
                                                    lineHeight: "34px",
                                                    fontWeight: 600,
                                                    margin: 0,
                                                    padding: 0,
                                                }}
                                                onChange={(e) => {
                                                    this.setCampaignName(e.target.value);
                                                }}
                                            />

                                            <div className="sectionBlock">
                                                <h2 className="blockHeader mb-20">Details</h2>

                                                <div className="mb-20">
                                                    <p className="small gray">Form Type</p>
                                                    <p>{data[0].type ? data[0].type : "N/A"}</p>
                                                </div>

                                                <div className="mb-20">
                                                    <p className="small gray">
                                                        Enable Attendance Confirmation
                                                    </p>
                                                    <p>{data[0].rsvpEnabled ? "Yes" : "No"}</p>
                                                </div>

                                                <div className="mb-20">
                                                    <p className="small gray">
                                                        Allow Anonymous Submissions
                                                    </p>
                                                    <p>{data[0].allowAnonymous ? "Yes" : "No"}</p>
                                                </div>

                                                <div className="mb-20">
                                                    <p className="small gray">Send Confirmation Email</p>
                                                    <p>
                                                        {data[0].confirmationEmailEnabled ? "Yes" : "No"}
                                                    </p>
                                                </div>

                                                <div className="mb-20">
                                                    <p className="small gray">
                                                        Pre-fill form with attendee data
                                                    </p>
                                                    <p>{data[0].preFillAttendeeData ? "Yes" : "No"}</p>
                                                </div>

                                                <div className="mb-20">
                                                    <p className="small gray">Show Progress Bar</p>
                                                    <p>{data[0].progressBarEnabled ? "Yes" : "No"}</p>
                                                </div>

                                                <div className="mb-20">
                                                    <p className="small gray">
                                                        Enable a review page before form submission
                                                    </p>
                                                    <p>{data[0].enableSubmissionReview ? "Yes" : "No"}</p>
                                                </div>

                                                <div className="mb-20">
                                                    <p className="small gray">
                                                        Allow attendees to decline attendance
                                                    </p>
                                                    <p>{data[0].denialEnabled ? "Yes" : "No"}</p>
                                                </div>

                                                {data[0].denialEnabled && (
                                                    <div>
                                                        <div className="mb-20">
                                                            <p className="small gray">
                                                                Enable Decline Options
                                                            </p>
                                                            <p>
                                                                {data[0].enableDeclineOptions ? "Yes" : "No"}
                                                            </p>
                                                        </div>

                                                        <div className="mb-20">
                                                            <p className="small gray">
                                                                Require Decline Options
                                                            </p>
                                                            <p>
                                                                {data[0].requireDeclineOptions ? "Yes" : "No"}
                                                            </p>
                                                        </div>

                                                        <div className="mb-20">
                                                            <p className="small gray">
                                                                Include Decline Comment
                                                            </p>
                                                            <p>
                                                                {data[0].enableDeclineComment ? "Yes" : "No"}
                                                            </p>
                                                        </div>

                                                        {data[0].enableDeclineComment && (
                                                            <div className="mb-20">
                                                                <p className="small gray">
                                                                    Require Decline Comment
                                                                </p>
                                                                <p>{data[0].requireComment ? "Yes" : "No"}</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    {selectedSection === 2 ? (
                                        <div className="formSection">
                                            <div className="formSectionContent">
                                                <div className=" formSectionCard m-a flex jcc aic">
                                                    <div
                                                        className="w-100 h-100 flex jcc aic"
                                                        style={{ flexDirection: "column" }}
                                                    >
                                                        <h1>Start From Scratch</h1>
                                                        <p className="mb-20">
                                                            Please complete the form below.
                                                        </p>

                                                        <InputField
                                                            label="Name"
                                                            onChange={(e) =>
                                                                this.setState({ campaignName: e.target.value })
                                                            }
                                                            value={campaignName}
                                                            required={true}
                                                            errorTrigger={requiredFields.name}
                                                        />
                                                        <SelectField
                                                            label="Form Type"
                                                            required={true}
                                                            errorTrigger={requiredFields.formType}
                                                            options={[
                                                                { value: 'registration', label: 'Registration' },
                                                                { value: 'general', label: 'General' },
                                                            ]}
                                                            onChange={(e) => {
                                                                this.setState({
                                                                    formType: e,
                                                                });
                                                            }}
                                                            value={formType}
                                                        />
                                                        <ToggleField
                                                            label="Enable Confirmation Email"
                                                            checked={confirmationEmailEnabled}
                                                            icons={false}
                                                            onChange={(e) => {
                                                                this.setState({
                                                                    confirmationEmailEnabled: e.target.checked,
                                                                });
                                                            }}
                                                        />
                                                        {confirmationEmailEnabled && (
                                                            <SelectField
                                                                label="Confirmation Email"
                                                                required={true}
                                                                errorTrigger={requiredFields.confirmationEmail}
                                                                options={this.props.availableEmails}
                                                                value={this.props.availableEmails.find(
                                                                    (e) => e.value == confirmationEmail
                                                                )}
                                                                onChange={(e) => {
                                                                    this.setState({
                                                                        confirmationEmail: e.value,
                                                                    });
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div
                                            style={{
                                                alignContent: "baseline",
                                                height: "calc(100vh - 233px)",
                                                overflow: "auto",
                                                display: "flex",
                                                flexFlow: "wrap",
                                            }}
                                        >
                                            {data.map((template, index) => {
                                                return (
                                                    <div>
                                                        <div className="templateCard mt-10">
                                                            <div className="templateCardHeader">
                                                                <div
                                                                    className="templateCardHeaderLeft"
                                                                    style={{ fontWeight: "600", fontSize: 14 }}
                                                                >
                                                                    <p
                                                                        style={{ fontWeight: "600", fontSize: 14 }}
                                                                    >
                                                                        {template.name}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className={`previewCardContainer ${template._id == this.state.templateSelected
                                                                ? "selected"
                                                                : ""
                                                                }`}
                                                            onClick={() => {
                                                                this.setCampaignName(
                                                                    this.state.templateSelected == template._id
                                                                        ? ""
                                                                        : template.name
                                                                );
                                                                this.selectTemplate(
                                                                    this.state.templateSelected == template._id
                                                                        ? null
                                                                        : template._id
                                                                );
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    opacity:
                                                                        template._id == this.state.templateSelected
                                                                            ? "0.4"
                                                                            : "1",
                                                                }}
                                                            >
                                                                <div
                                                                    className="noselect emailPreviewWindow Frame templateCenter form"
                                                                    style={{ width: "100%" }}
                                                                >
                                                                    <PagePreviewFrame
                                                                        ENV={ENV}
                                                                        name={`PreviewFrame-${index}-${countingKey}`}
                                                                        renderURL={
                                                                            programId
                                                                                ? `Organizations/${orgId}/programs/${programId}/render/platformFormRender/`
                                                                                : `Organizations/${orgId}/events/${eventId}/pages/render/platformFormRender/`
                                                                        }
                                                                        pageProperties={{}}
                                                                        focusedComponent={""}
                                                                        simulatedUser={{ value: "" }}
                                                                        simulatedSession={{ value: false }}
                                                                        renderOnly={true}
                                                                        formId={template._id}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            )}
                            <div className="modalFooter mt-20">
                                <div className="flex">
                                    <button className="neu ml-a" onClick={this.onCancel}>
                                        {isConfirmation ? "Back" : "Cancel"}
                                    </button>
                                    <button
                                        className={`ml-25 ${!templateSelected &&
                                            !isConfirmation &&
                                            selectedSection !== 2 &&
                                            selectedSection !== 3
                                            ? "disabled"
                                            : this.state.campaignName === ""
                                                ? "disabled"
                                                : "prim"
                                            }`}
                                        onClick={() => {
                                            this.handleActionButtonLogic();
                                        }}
                                    >
                                        {(selectedSection === 0 || selectedSection === 1) &&
                                            templateSelected &&
                                            !isConfirmation
                                            ? "Next"
                                            : "Create Form"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default withRouter(FormsTemplateCenter);
